export const MovementsTableColumns = [
    { id: "product",     labelEn: "Product",     labelAr: "المنتج",      align: "left",   sortable: false },
    { id: "warehouse",   labelEn: "Warehouse",   labelAr: "المستودع",    align: "center", sortable: false },
    { id: "qty_change",  labelEn: "Change",      labelAr: "التغيير",     align: "center", sortable: false },
    { id: "qty_flow",    labelEn: "Before → After", labelAr: "قبل → بعد", align: "center", sortable: false },
    { id: "reason",      labelEn: "Reason",      labelAr: "السبب",       align: "center", sortable: false },
    { id: "reference",   labelEn: "Reference",   labelAr: "المرجع",      align: "center", sortable: false },
    { id: "actor",       labelEn: "Actor",       labelAr: "المنفّذ",     align: "center", sortable: false },
    { id: "created_at",  labelEn: "When",        labelAr: "التاريخ",     align: "center", sortable: false },
];
